const API_BASE = "/api/ch";

export interface FilingRequest {
  companyNumber: string;
  companyName: string;
  companyType: string;
  companyAuthCode: string;
  accountsBase64: string;
  filename?: string;
  formType: string;
  dateSigned?: string;
  contactName?: string;
  contactNumber?: string;
}

export interface FilingResponse {
  submissionId: string;
  submissionNumber: string;
  status: string;
  message: string;
}

export const companiesHouseApi = {
  async getStatus() {
    const res = await fetch(`${API_BASE}/status`);
    if (!res.ok) throw new Error("Failed to check CH status");
    return res.json();
  },

  async lookupCompany(companyNumber: string) {
    const res = await fetch(`${API_BASE}/company/${encodeURIComponent(companyNumber)}`, {
      method: "POST",
    });
    if (!res.ok) throw new Error(`Lookup failed: ${res.status}`);
    return res.json();
  },

  async searchCompanies(query: string) {
    const res = await fetch(`${API_BASE}/search?q=${encodeURIComponent(query)}`);
    if (!res.ok) throw new Error(`Search failed: ${res.status}`);
    return res.json();
  },

  async validateFiling(body: FilingRequest) {
    const res = await fetch(`${API_BASE}/validate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`Validation failed: ${res.status}`);
    return res.json();
  },

  async fileAccounts(body: FilingRequest) {
    const res = await fetch(`${API_BASE}/file-accounts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`Filing failed: ${res.status}`);
    return res.json() as Promise<FilingResponse>;
  },
};
